const siderBar = {
  profile: "Профайл",
  history: "История",
  setting: "Настройка",
  promotion: "Льгота",
};

export default siderBar;